import { css, html, LitElement, PropertyValues, TemplateResult } from "lit";
import {property, customElement} from 'lit/decorators.js';
import { TerminalsModel } from "../../../src/models/terminals-model";
import { VesselInfo } from "../../../src/models/types/vessels-model.types";
import { ScheduleEntry } from "../../../src/models/types/voyage-schedules-model.types";
import { FiSubView, UiStateModel, UiStateModelParam } from "../../../src/models/ui-state-model";
import { VoyageSchedulesModel } from "../../../src/models/voyage-schedules-model";
import { VoyageShoreContextModel } from "../../../src/models/voyage-shore-context-model";
import { FormatDateToLocalTime, GetFormattedDate, THREE_MONTHS } from "../../../src/utils/helpers";
import { SvgIcons } from "../../voyage-svg-icons/src/voyage-svg-icons";
import { VesselsModel } from "../../../src/models/vessels-model";
import { ShoreContextEvent } from "../../../src/models/types/voyage-shore-context-model.types";
import { VesselVoyageVersion } from "../../voy-global-filters/src/types";
import { AuthService } from "../../../src/services/auth-service";

@customElement('voy-fleet-sub-view-schedule')
export class VoyFleetSubViewSchedule extends LitElement {
    @property({ type: Number }) public imo?: number;
    @property({ type: Array }) private _schedules: ScheduleEntry[] = [];
    @property({ type: Object, attribute: false }) private _vessel?: VesselInfo;
    @property({ type:Boolean }) private  _timeLineVisible : any =  false

    constructor() {
        super();

        this._setVessel = this._setVessel.bind(this);
        this._setSchedule = this._setSchedule.bind(this);
        this._back = this._back.bind(this);
        this._renderDateColumn = this._renderDateColumn.bind(this);
        this._toggleTimeLine = this._toggleTimeLine.bind(this);
        // this._showVoyageSummary = this._showVoyageSummary.bind(this);
        if(localStorage.getItem("timeLineView")!==undefined) {
            this._timeLineVisible = localStorage.getItem("timeLineView")=="true";
        }
    }

    static get styles() {
        return [
            css`
                h1 {
                    font-size: 26px;
                    line-height: 32px;
                    margin: 0;
                    font-weight: 400;
                    color: var(--neutrals-grey-02);
                    font-family: MaerskHeadline;
                }
                header {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    column-gap: 4px;
                }
                header button {
                    background: none;
                    border: none;
                    margin-top: 6px;
                    cursor: pointer;
                    padding: 0px;
                    margin-left: -6px;
                    display: flex;
                }

                section {
                    display: flex;
                    flex-direction: row;
                    padding: 16px;
                }

                section:nth-of-type(1) {
                    border-bottom: 1px solid var(--neutrals-grey-06);
                    box-shadow: var(--voyage-box-shadow) 0px 6px 10px;
                    padding: 24px 16px;
                }

                .scroll-container {
                    max-height: calc(100vh - 308px);
                    overflow-y: auto;
                }

                .scroll-container-full {
                    max-height: calc(100vh - 251px);
                }

                .inner {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    height: fit-content;
                }

                .timeline {
                    width: 12px;
                    background-color: var(--neutrals-grey-07, #DBDBDB);
                    border-radius: 4px;
                    margin-right: 16px;
                }

                .progress {
                    width: 12px;
                    position: relative;
                    background-color: var(--primary-blue-04);
                }
                .progress:after {
                    content: " ";
                    position: absolute;
                    width: 0px;
                    height: 0px;
                    border-left: 6px solid transparent;
                    border-right: 6px solid transparent;
                    border-top: 5px solid var(--primary-blue-04);
                    bottom: -5px;
                }

                .entries {
                    display: flex;
                    flex-direction: column;
                    row-gap: 16px;
                    width: 100%;
                    height: fit-content;
                }

                .schedule-entry {
                    display: flex;
                    padding: 8px;
                    flex-direction: column;
                    row-gap: 16px;
                    column-gap: 16px;
                    border: 1px solid var(--neutrals-grey-04);
                    cursor: default;
                    position: relative;
                    font-size: 12px;
                    font-family: MaerskText;
                }
                .schedule-entry[active=true] {
                    border-color: var(--primary-blue-04);
                    border-radius: 4px;
                }
                .schedule-entry[completed=true],
                .schedule-entry[completed=true] + p {
                    opacity: 0.6;
                }
                .schedule-entry[completed=true]:hover {
                    opacity: 1;
                }
                .schedule-entry h2 {
                    font-family: MaerskText;
                    font-size: 14px;
                    line-height: 20px;
                    margin: 0 0 4px;
                    color: var(--primary-blue-04);
                    position: relative;
                }
                .schedule-entry h2:before {
                    position: absolute;
                    content: " ";
                    width: 8px;
                    height: 8px;
                    background-color: var(--neutrals-grey-10);
                    border-radius: 100%;
                    left: -35px;
                    top: 7px;
                }
                .schedule-entry .terminal-name {
                    font-weight: bold;
                }
                .schedule-entry .terminal-code {
                    font-weight: lighter
                }

                .anchor-time {
                    font-size: 12px;
                    color: var(--neutrals-grey-04);
                    margin: 0;
                    display: flex;
                    align-items: center;
                    width: 100%;
                }

                .anchor-time svg {
                    width: 16px;
                    margin-right: 8px;
                }

                .timetable {
                    display: flex;
                    flex-direction: row;
                    column-gap: 16px;
                }
                .timetable p {
                    font-size: 12px;
                    line-height: 12px;
                    margin: 0;
                    color: var(--neutrals-grey-02);
                    margin-bottom: 4px;
                }
                .timetable h3 {
                    width: 5rem;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 14px;
                    margin: 0 0 4px;
                    color: var(--neutrals-grey-04);
                }
                .timetable div {
                    flex: 1 1 50%;
                }
                .premium-icon svg{
                    height: 16px;
                    width: 16px;
                }
                .header-container{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
            `
        ];
    }

    private async _setVessel() {
        if (!this.imo) return;
        this._vessel = VoyageShoreContextModel!.vessels.find(v => v.imoNo === this.imo)
        if(!this._vessel){
            await VesselsModel?.refreshVessels()
            this._vessel = VesselsModel!.getVessel(this.imo)
        } 
    }

    private async _setSchedule(): Promise<void> {
        if (!this.imo) return;
        const fromDate = new Date()
        fromDate.setMonth(fromDate.getMonth() - 3)

        const schedules = await VoyageSchedulesModel!.getScheduleFor(this.imo, 0, THREE_MONTHS)
        this._schedules = schedules ?? [];
    }

    private _back(): void {
        UiStateModel!.setValue(UiStateModelParam.FISubView, FiSubView.VesselDetails);
    }

    private _formatAnchoringDate(date1: number, date2: number) {
        let difference = (date2 - date1) / 60;
        if (difference < 0) {
            return '';
        }

        let hours = Math.floor(difference / 60 / 1000);
        let days = Math.floor(hours / 24);
        hours = hours - (days * 24);
        return `Port stay: ${days}d ${hours}h ${Math.floor((difference % 60000) / 1000)}m`;
    }

    private _renderDateColumn(date: string | number, terminal: string) {
        const zone = TerminalsModel!.getTerminal(terminal)?.olsonTimezone;
        return zone ? FormatDateToLocalTime(date, zone) : GetFormattedDate(date);
    }

    private _renderEntry(scheduleEntry: ScheduleEntry, index: number): TemplateResult {
        const nextSchedule = this._schedules[index + 1];

        const departureTerminalCity = TerminalsModel!.getTerminal(scheduleEntry.departureTerminalCode)?.city;
        const arrivalTerminalCity = TerminalsModel!.getTerminal(scheduleEntry.arrivalTerminalCode)?.city;
        const departureActuals = scheduleEntry.departurePortCall?.GSIS?.actuals;
        const arrivalActuals = scheduleEntry.arrivalPortCall?.GSIS?.actuals;

        const today = new Date();
        const scheduleDeparture = new Date(scheduleEntry.departureAt);
        const active = scheduleEntry.active;
        const completed = (!scheduleEntry.active && scheduleDeparture.getTime() < today.getTime());

        const username: string = AuthService.getUserDetails()

        return html`
            <div class="schedule-entry" active=${scheduleEntry.active} completed=${!scheduleEntry.active && scheduleDeparture.getTime() < today.getTime()}>
                <div class="departure">
                    <div class="header-container">
                        <h2 data-test="depcode">
                            <span class="terminal-name">${departureTerminalCity}</span>
                            <span class="terminal-code">(${scheduleEntry.departureTerminalCode})</span>
                        </h2>
                    </div>
                    <div class="timetable">
                        <div>
                            <p data-test="deplbl">Departure (${!!departureActuals?.departureAt ? "actual" : "scheduled"})</p>
                            <h3 data-test="depts">
                                ${!!departureActuals?.departureAt
                                    ? this._renderDateColumn(departureActuals.departureAt, scheduleEntry.departureTerminalCode )
                                    : this._renderDateColumn(scheduleEntry.etd , scheduleEntry.departureTerminalCode )
                                }
                            </h3>
                        </div>
                        <div>
                            <p data-test="deppilotlbl">Pilot off ${!!departureActuals?.pilotOffAt ? "(actual)" : ""}</p>
                            <h3 data-test="deppilotts">
                                ${departureActuals?.pilotOffAt
                                    ? this._renderDateColumn(departureActuals.pilotOffAt, scheduleEntry.departureTerminalCode)
                                    : scheduleEntry.departurePortCall?.GSIS?.estimatedpilotdropoff ? this._renderDateColumn(scheduleEntry.departurePortCall?.GSIS?.estimatedpilotdropoff, scheduleEntry.departureTerminalCode) : "--"
                                }
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="arrival">
                    <h2 data-test="arrcode">
                        <span class="terminal-name">${arrivalTerminalCity}</span>
                        <span class="terminal-code">(${scheduleEntry.arrivalTerminalCode})</span>
                    </h2>
                    <div class="timetable">
                        <div>
                            <p data-test="arrpilotlbl">Pilot on ${!!arrivalActuals?.pilotOnAt ? "(actual)" : ""}</p>
                            <h3 data-test="arrpilotts">
                                ${!!arrivalActuals?.pilotOnAt
                                    ? this._renderDateColumn(arrivalActuals.pilotOnAt, scheduleEntry.arrivalTerminalCode)
                                    : scheduleEntry.arrivalPortCall?.GSIS?.estimatedpilotboarding ? this._renderDateColumn(scheduleEntry.arrivalPortCall?.GSIS?.estimatedpilotboarding, scheduleEntry.arrivalTerminalCode) : "--"
                                }
                            </h3>
                        </div>
                        <div>
                            <p data-test="arrlbl">Arrival (${!!arrivalActuals?.arrivalAt ? "actual" : "scheduled"})</p>
                            <h3 data-test="arrts">
                                ${!!arrivalActuals?.arrivalAt
                                    ? this._renderDateColumn(arrivalActuals.arrivalAt, scheduleEntry.arrivalTerminalCode)
                                    : this._renderDateColumn(scheduleEntry.eta, scheduleEntry.arrivalTerminalCode)
                                }
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            ${nextSchedule ? html`<p class="anchor-time" data-test="anchortime">${SvgIcons.portListIcon}${this._formatAnchoringDate(scheduleEntry.eta, nextSchedule.etd)}</p>` : html``}
        `
    }

    render() {
        let className = this._timeLineVisible ? "scroll-container" : "scroll-container scroll-container-full"
        const isPremium:boolean = this._vessel?.vesselVersion === VesselVoyageVersion.Premium;

        return html`
            <section>
                <header>
                    <button @click=${this._back} data-test="back-button">${SvgIcons.customChevronLeft}</button>
                    <h1><span class="premium-icon" ?hidden=${!isPremium}>${SvgIcons.customPremiumVessel}</span>${this._vessel?.vesselName}<br>Schedule</h1>
                </header>
            </section>
            <section class=${className}>
                <div class="inner">
                    <div class="timeline">
                        <div class="progress"></div>
                    </div>
                    <div class="entries" data-test="schedule-entries">
                        ${this._schedules.map((s, i) => this._renderEntry(s, i))}
                    </div>
                </div>
            </section>
        `
    }

    connectedCallback() {
        super.connectedCallback();

        this._setVessel();
        this._setSchedule();

        VoyageSchedulesModel!.addEventListener('schedule-updated', this._setSchedule);
        VoyageShoreContextModel!.addEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        VoyageSchedulesModel!.removeEventListener('schedule-updated', this._setSchedule);
        VoyageShoreContextModel!.removeEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);
    }

    updated(changedProperties: PropertyValues) {
        if (changedProperties.has("_schedules")) {
            const scrollContainer = <HTMLElement>this.shadowRoot?.querySelector(".scroll-container");
            const activeSchedule = <HTMLElement>scrollContainer?.querySelector("div[active=true]")
            const progressBar = <HTMLElement>scrollContainer?.querySelector(".progress")

            activeSchedule?.scrollIntoView({ behavior: "smooth", block: "center" });
            progressBar.style.height = `${activeSchedule?.offsetTop - scrollContainer?.offsetTop + (activeSchedule?.offsetHeight / 4)}px`
        }
    }

    private _toggleTimeLine():void {
        this._timeLineVisible = !this._timeLineVisible
    }

}
